import React, { useLayoutEffect, useRef, useState } from 'react';

import { useEventListener } from '../../hooks/useEventListener';

interface StuckProps {
    when: (rect: ClientRect | DOMRect) => boolean;
    render: (isStuck: boolean) => JSX.Element;
}

export const Stuck: React.FC<StuckProps> = ({ render, when }) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const [isStuck, setIsStuck] = useState(false);
    const [initialHeight, setInitialHeight] = useState<string>('');

    useLayoutEffect(() => {
        setInitialHeight(getComputedStyle(containerRef.current!).height || '');
    }, []);

    useEventListener(window, 'scroll', () => {
        const isElementGoesOutsideViewport = when(containerRef.current!.getBoundingClientRect());

        setIsStuck(isElementGoesOutsideViewport);
    });

    return (
        <div ref={containerRef} style={{ height: initialHeight }}>
            {render(isStuck)}
        </div>
    );
};
